import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { WA_LABEL, fmtDate } from "../SuperHeader";
import { Stat } from "../useAdminFetch";
import { api } from "@/lib/api";

function BackupLink({ id }) {
  const download = async () => {
    const r = await api.get(`/admin/backups/${id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a"); a.href = url; a.download = `${id}.json`; a.click(); URL.revokeObjectURL(url);
  };
  return <button onClick={download} className="underline" data-testid="backup-download">Download backup</button>;
}

export default function OverviewTab({ detail }) {
  const { company, admin, counts, wa_state, recent_activity } = detail;
  const wa = WA_LABEL[wa_state] || WA_LABEL.none;
  return (
    <div className="grid lg:grid-cols-3 gap-4" data-testid="overview-tab">
      <Card className="p-5 border-slate-200 lg:col-span-2 space-y-4">
        <dl className="grid sm:grid-cols-2 gap-3 text-sm">
          <div><dt className="text-xs text-slate-500">Registered</dt><dd data-testid="overview-registered">{fmtDate(company.created_at)}</dd></div>
          <div><dt className="text-xs text-slate-500">Plan</dt><dd className="capitalize">{company.plan || "—"}</dd></div>
          <div><dt className="text-xs text-slate-500">Company Admin</dt><dd data-testid="overview-admin">{admin ? `${admin.name} · ${admin.email}` : "No admin"}</dd></div>
          <div><dt className="text-xs text-slate-500">WhatsApp health</dt><dd><Badge className={wa.cls} data-testid="overview-wa">{wa.text}</Badge></dd></div>
          {company.status === "disabled" && (
            <div className="sm:col-span-2 p-3 rounded-lg bg-slate-100 border border-slate-200 text-slate-700 text-xs">
              Disabled {fmtDate(company.disabled_at || company.suspended_at)}{company.suspend_reason ? ` — ${company.suspend_reason}` : ""}
            </div>
          )}
          {company.status === "rejected" && (
            <div className="sm:col-span-2 p-3 rounded-lg bg-rose-50 border border-rose-100 text-rose-800 text-xs" data-testid="overview-reject-reason">
              Rejected {fmtDate(company.rejected_at)} — {company.reject_reason}
            </div>
          )}
          {company.status === "deleted" && (
            <div className="sm:col-span-2 p-3 rounded-lg bg-slate-800 text-white text-xs space-y-1" data-testid="overview-deleted">
              <div>Deleted {fmtDate(company.deleted_at)} · all tenant data erased.</div>
              {company.backup_id ? <div>Backup kept until {fmtDate(company.backup_expires_at)} · <BackupLink id={company.backup_id} /></div> : <div>No backup was kept.</div>}
            </div>
          )}
          <div><dt className="text-xs text-slate-500">Mobile</dt><dd data-testid="overview-phone">{company.phone || admin?.phone || "—"}</dd></div>
          <div><dt className="text-xs text-slate-500">Industry</dt><dd>{company.industry || "—"}</dd></div>
          <div><dt className="text-xs text-slate-500">Location</dt><dd>{[company.city, company.country].filter(Boolean).join(", ") || "—"}</dd></div>
          <div><dt className="text-xs text-slate-500">Website</dt><dd className="break-all">{company.website || "—"}</dd></div>
        </dl>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
          <Stat label="Users" value={counts.users} testid="overview-users" />
          <Stat label="Contacts" value={counts.contacts} testid="overview-contacts" />
          <Stat label="Leads" value={counts.leads} testid="overview-leads" />
          <Stat label="Conversations" value={counts.conversations} testid="overview-conversations" />
          <Stat label="Campaigns" value={counts.campaigns} testid="overview-campaigns" />
        </div>
      </Card>
      <Card className="p-5 border-slate-200">
        <h3 className="font-semibold text-slate-900 mb-2">Recent activity</h3>
        {recent_activity.length === 0 ? <p className="text-xs text-slate-500">No recorded activity yet.</p> : (
          <ul className="space-y-2 text-xs" data-testid="overview-activity">
            {recent_activity.map((a, i) => (
              <li key={i} className="border-b border-slate-100 pb-1.5">
                <div className="font-medium text-slate-800">{a.action.replaceAll("_", " ")}</div>
                <div className="text-slate-500">{a.actor_email || "system"} · {fmtDate(a.at)}</div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
